import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {InitService} from "../../services/init.service";
import {CognitoService, IUser} from "../../services/cognito.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginValid = true;
  imgLogo = 'assets/brand/explo-original-verde-crop.svg';
  loginForm!: FormGroup;

  loading: boolean = false;
  user: any = {};

  constructor(private fb: FormBuilder, private router: Router, private cognitoService: CognitoService,private serviceInit: InitService) {
    this.loading = false;
    this.user = {} as IUser;
    this.serviceInit.setEstadoLayout(false);
  }



  ngOnInit(): void {

    this.loginForm = this.fb.group({
      username: new FormControl('', {nonNullable: true}),
      password: new FormControl('', {nonNullable: true}),
    });

  }



  public submit(): void {
    this.loading = true;
    this.user.email = this.loginForm.value.username;
    this.user.password = this.loginForm.value.password;
    this.cognitoService.signIn(this.user)
      .then((res) => {
        if(res){
          console.log('res',res);
          return this.cognitoService.getRol();
          // this.serviceInit.setEstadoLayout(true);
          // this.router.navigate(['/home']);
        }else{
          this.loginForm.reset();
          this.loading = false;
          return false;
        }
      })
      .then((rolValue)=>{
        console.log(rolValue)
        if (rolValue.includes('ADMIN_WAREHOUSE') || rolValue.includes('ACCESS_DEV')) {
          this.serviceInit.setEstadoLayout(true);
          this.router.navigate(['/home']);
        }
        else{
          console.log('Rol equivocado')
        }
      })
      .catch(() => {
        this.loginForm.reset();
        this.loading = false;
      });
  }

}
